<template>
  <BaseDialog max-width="900" persistent :value="true">
    <template #modal>
      <BaseCosmoCard>
        <template #title>
          <div class="modal_header">
            <BaseTitle v-text="dialogTitle" />
            <BaseButtonIcon
              class="close_icon"
              icon="$mdiClose"
              :disabled="isSubmiting"
              @click="$emit('close')"
            />
          </div>
        </template>
        <div class="modal_content">
          <!-- <v-progress-linear class="progression" indeterminate /> -->
          <div class="field_container">
            <div class="label_content">{{ $t("utils.label") }}</div>
            <base-text-field
              v-model="form.label"
              outlined
              :has-error="!!labelErrors"
              :error-messages="labelErrors"
            />
          </div>
          <div class="field_title">{{ $t("workflow.operation.title") }}</div>
          <div class="field_container">
            <base-autocomplete
              v-model="form.first_operator"
              :loading="wfQuestions.loading"
              :items="formatedQuestions"
              :filter="() => true"
              :search-input.sync="wfQuestions.name"
              item-text="name"
              item-value="id"
              clearable
              :label="$t('workflow.operation.firstOperator')"
              :has-error="!!firstOperatorErrors"
              :error-messages="firstOperatorErrors"
              need-selection
              display-selection
            >
              <template #item="{ item }">
                <div class="d-flex align-items-center">
                  {{ item.name }}
                  <div
                    v-if="item.isOperationResult"
                    class="tooltip_container ml-2"
                  >
                    <base-icon
                      icon="$mdiCalculatorVariant"
                      small
                      color="primary"
                      class="tag_item"
                    />
                    <div class="tooltip_item">
                      <div class="msg_contain">
                        {{ $t("utils.calculatedField") }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template #selection="{ item }">
                <div class="d-flex align-items-center">
                  {{ item.name }}
                  <div
                    v-if="item.isOperationResult"
                    class="tooltip_container ml-2"
                  >
                    <base-icon
                      icon="$mdiCalculatorVariant"
                      small
                      color="primary"
                      class="tag_item"
                    />
                    <div class="tooltip_item">
                      <div class="msg_contain">
                        {{ $t("utils.calculatedField") }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template #append-item>
                <div v-intersect="loadMoreWorkflowQuestions" />
              </template>
            </base-autocomplete>
          </div>
          <div class="operations_container">
            <div
              class="operation_item"
              :class="{ active: form.operator == '+' }"
              @click="setOperator('+')"
            >
              +
            </div>
            <div
              class="operation_item"
              :class="{ active: form.operator == '-' }"
              @click="setOperator('-')"
            >
              -
            </div>
            <div
              class="operation_item"
              :class="{ active: form.operator == '*' }"
              @click="setOperator('*')"
            >
              x
            </div>
            <div
              class="operation_item"
              :class="{ active: form.operator == '/' }"
              @click="setOperator('/')"
            >
              /
            </div>
          </div>
          <div class="field_container">
            <base-autocomplete
              v-model="form.second_operator"
              :loading="wfQuestions2.loading"
              :items="formatedQuestions2"
              :filter="() => true"
              :search-input.sync="wfQuestions2.name"
              item-text="name"
              item-value="id"
              clearable
              :label="$t('workflow.operation.secondOperator')"
              :has-error="!!secondOperatorErrors"
              :error-messages="secondOperatorErrors"
              need-selection
              display-selection
            >
              <template #item="{ item }">
                <div class="d-flex align-items-center">
                  {{ item.name }}
                  <div
                    v-if="item.isOperationResult"
                    class="tooltip_container ml-2"
                  >
                    <base-icon
                      icon="$mdiCalculatorVariant"
                      small
                      color="primary"
                      class="tag_item"
                    />
                    <div class="tooltip_item">
                      <div class="msg_contain">
                        {{ $t("utils.calculatedField") }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template #selection="{ item }">
                <div class="d-flex align-items-center">
                  {{ item.name }}
                  <div
                    v-if="item.isOperationResult"
                    class="tooltip_container ml-2"
                  >
                    <base-icon
                      icon="$mdiCalculatorVariant"
                      small
                      color="primary"
                      class="tag_item"
                    />
                    <div class="tooltip_item">
                      <div class="msg_contain">
                        {{ $t("utils.calculatedField") }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template #append-item>
                <div v-intersect="loadMoreWorkflowQuestions2" />
              </template>
            </base-autocomplete>
          </div>
          <div class="field_title">{{ $t("workflow.operation.result") }}</div>
          <div class="field_container">
            <base-autocomplete
              v-model="form.result_field"
              :loading="wfQuestions3.loading"
              :items="formatedQuestions3"
              :filter="() => true"
              :search-input.sync="wfQuestions3.name"
              item-text="name"
              item-value="id"
              clearable
              :label="$t('workflow.operation.resultField')"
              :has-error="!!resultFieldOperators"
              :error-messages="resultFieldOperators"
              need-selection
              display-selection
            >
              <template #item="{ item }">
                <div class="d-flex align-items-center">
                  {{ item.name }}
                  <div
                    v-if="item.isOperationResult"
                    class="tooltip_container ml-2"
                  >
                    <base-icon
                      icon="$mdiCalculatorVariant"
                      small
                      color="primary"
                      class="tag_item"
                    />
                    <div class="tooltip_item">
                      <div class="msg_contain">
                        {{ $t("utils.calculatedField") }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template #selection="{ item }">
                <div class="d-flex align-items-center">
                  {{ item.name }}
                  <div
                    v-if="item.isOperationResult"
                    class="tooltip_container ml-2"
                  >
                    <base-icon
                      icon="$mdiCalculatorVariant"
                      small
                      color="primary"
                      class="tag_item"
                    />
                    <div class="tooltip_item">
                      <div class="msg_contain">
                        {{ $t("utils.calculatedField") }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template #append-item>
                <div v-intersect="loadMoreWorkflowQuestions3" />
              </template>
            </base-autocomplete>
          </div>
        </div>
        <div class="modal_footer">
          <BaseButton
            :disabled="isSubmiting"
            color="grey"
            type="secondary"
            @click="$emit('close')"
          >
            {{ $t("utils.cancel") }}
          </BaseButton>
          <BaseButton
            :disabled="isSubmiting"
            color="primary"
            type="primary"
            @click="submit()"
          >
            {{ $t("utils.validate") }}
          </BaseButton>
        </div>
      </BaseCosmoCard>
    </template>
  </BaseDialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { getWorkflowQuestions } from "@/modules/Admin/Services/workflow.service";
import workflowApi from "../Services/workflow.api";
import { Operation } from "@/core/Models/Operation";
import QuestionTemplate from "@/core/Models/QuestionTemplate";

export default {
  name: "OperationCreateAndEditDialog",
  mixins: [validationMixin],
  props: {
    organizationId: {
      type: [Number, String],
      required: true,
    },
    selectedOperation: {
      type: Operation,
      default: () => {},
    },
  },
  data() {
    return {
      wfQuestions: {
        page: 1,
        pageSize: 10,
        name: undefined,
        items: [],
        loading: false,
        next: null,
      },
      wfQuestions2: {
        page: 1,
        pageSize: 10,
        name: undefined,
        items: [],
        loading: false,
        next: null,
      },
      wfQuestions3: {
        page: 1,
        pageSize: 10,
        name: undefined,
        items: [],
        loading: false,
        next: null,
      },
      form: {
        label: null,
        first_operator: null,
        second_operator: null,
        operator: "+",
        result_field: null,
      },
      isSubmiting: false,
    };
  },
  validations() {
    let validations = {};
    validations.form = {
      label: {
        required,
      },
      first_operator: {
        required,
      },
      operator: {
        required,
      },
      second_operator: {
        required,
      },
      result_field: {
        required,
      },
    };
    return validations;
  },
  computed: {
    dialogTitle() {
      return this.selectedOperation
        ? this.$t("workflow.operation.editAutomatedOperation")
        : this.$t("workflow.operation.createAutomatedOperation");
    },
    labelErrors() {
      if (!this.$v.form.label.$dirty) {
        return "";
      }
      if (!this.$v.form.label.required) {
        return this.$t("inactive_alert.errors.required");
      }
      return "";
    },
    firstOperatorErrors() {
      if (!this.$v.form.first_operator.$dirty) {
        return "";
      }
      if (!this.$v.form.first_operator.required) {
        return this.$t("inactive_alert.errors.required");
      }
      return "";
    },
    secondOperatorErrors() {
      if (!this.$v.form.second_operator.$dirty) {
        return "";
      }
      if (!this.$v.form.second_operator.required) {
        return this.$t("inactive_alert.errors.required");
      }
      return "";
    },
    resultFieldOperators() {
      if (!this.$v.form.result_field.$dirty) {
        return "";
      }
      if (!this.$v.form.result_field.required) {
        return this.$t("inactive_alert.errors.required");
      }
      return "";
    },
    formatedQuestions() {
      if (!this.form.second_operator && !this.form.result_field)
        return this.wfQuestions.items;
      return this.wfQuestions.items?.filter(
        (q) =>
          ![this.form.second_operator, this.form.result_field].includes(q.id)
      );
    },
    formatedQuestions2() {
      if (!this.form.first_operator && !this.form.result_field)
        return this.wfQuestions2.items;
      return this.wfQuestions2.items?.filter(
        (q) =>
          ![this.form.result_field, this.form.first_operator].includes(q.id)
      );
    },
    formatedQuestions3() {
      if (!this.form.second_operator && !this.form.first_operator)
        return this.wfQuestions3.items;
      return this.wfQuestions3.items?.filter(
        (q) =>
          ![this.form.second_operator, this.form.first_operator].includes(q.id)
      );
    },
  },
  watch: {
    "wfQuestions.name"(newVal, oldVal) {
      if (newVal == oldVal || oldVal == null) return;
      this.filterWfQuestions();
    },
    "wfQuestions2.name"(newVal, oldVal) {
      if (newVal == oldVal || oldVal == null) return;
      this.filterWfQuestions2();
    },
    "wfQuestions3.name"(newVal, oldVal) {
      if (newVal == oldVal || oldVal == null) return;
      this.filterWfQuestions3();
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async submit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;
      try {
        if (this.selectedOperation) {
          const response =
            await workflowApi.patchOrganizationWorkflowOperations(
              this.$route.params.organizationId,
              this.$route.params.workflowId,
              this.selectedOperation.id,
              { ...this.form }
            );
          this.$emit("operation-edited", {
            id: this.selectedOperation?.id,
            data: new Operation(response.data),
          });
        } else {
          await workflowApi.postOrganizationWorkflowOperations(
            this.$route.params.organizationId,
            this.$route.params.workflowId,
            { ...this.form }
          );
          this.$emit("operation-created");
          this.$store.dispatch("snackbar/active", {
            message: "OPERATION Cree avec succes",
            type: "SUCCESS",
          });
        }
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.$emit("close");
    },
    async initialize() {
      const response = await getWorkflowQuestions({
        organizationId: this.$route.params.organizationId,
        workflowId: this.$route.params.workflowId,
        std_only: true,
        page: this.wfQuestions.page,
        name: this.wfQuestions.name,
        pageSize: this.wfQuestions.pageSize,
        typeQuestion: ["NUMBER"],
      });
      this.wfQuestions = { ...this.wfQuestions, ...response };
      this.wfQuestions2 = { ...this.wfQuestions2, ...response };
      this.wfQuestions3 = { ...this.wfQuestions3, ...response };
      if (this.selectedOperation) {
        this.form.label = this.selectedOperation.label;
        this.form.operator = this.selectedOperation.operator;
        this.wfQuestions.items = [
          ...this.wfQuestions.items.filter(
            (op) => op.id !== this.selectedOperation?.firstOperator?.id
          ),
          new QuestionTemplate(this.selectedOperation.firstOperator),
        ];
        this.wfQuestions2.items = [
          ...this.wfQuestions2.items.filter(
            (op) => op.id !== this.selectedOperation?.secondOperator?.id
          ),
          new QuestionTemplate(this.selectedOperation.secondOperator),
        ];
        this.wfQuestions3.items = [
          ...this.wfQuestions3.items.filter(
            (op) => op.id !== this.selectedOperation?.resultField?.id
          ),
          new QuestionTemplate(this.selectedOperation.resultField),
        ];
        this.$nextTick();
        this.form.first_operator = this.selectedOperation?.firstOperator?.id;
        this.form.second_operator = this.selectedOperation?.secondOperator?.id;
        this.form.result_field = this.selectedOperation?.resultField?.id;
      }
    },
    setOperator(item) {
      this.form.operator = item;
    },
    async fetchWorkflowQuestion() {
      this.wfQuestions.loading = true;
      try {
        const response = await getWorkflowQuestions({
          organizationId: this.$route.params.organizationId,
          workflowId: this.$route.params.workflowId,
          page: this.wfQuestions.page,
          name: this.wfQuestions.name,
          pageSize: this.wfQuestions.pageSize,
          std_only: true,
          typeQuestion: ["NUMBER"],
        });
        this.wfQuestions = {
          ...this.wfQuestions,
          ...response,
          items: [...this.wfQuestions.items, ...response.items],
        };
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.wfQuestions.loading = false;
    },
    async fetchWorkflowQuestion2() {
      this.wfQuestions2.loading = true;
      try {
        const response = await getWorkflowQuestions({
          organizationId: this.$route.params.organizationId,
          workflowId: this.$route.params.workflowId,
          page: this.wfQuestions2.page,
          name: this.wfQuestions2.name,
          pageSize: this.wfQuestions2.pageSize,
          std_only: true,
          typeQuestion: ["NUMBER"],
        });
        this.wfQuestions2 = {
          ...this.wfQuestions2,
          ...response,
          items: [...this.wfQuestions2.items, ...response.items],
        };
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.wfQuestions2.loading = false;
    },
    async fetchWorkflowQuestion3() {
      this.wfQuestions3.loading = true;
      try {
        const response = await getWorkflowQuestions({
          organizationId: this.$route.params.organizationId,
          workflowId: this.$route.params.workflowId,
          page: this.wfQuestions3.page,
          name: this.wfQuestions3.name,
          pageSize: this.wfQuestions3.pageSize,
          std_only: true,
          typeQuestion: ["NUMBER"],
        });
        this.wfQuestions3 = {
          ...this.wfQuestions3,
          ...response,
          items: [...this.wfQuestions3.items, ...response.items],
        };
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.wfQuestions3.loading = false;
    },
    filterWfQuestions() {
      if (this.wfQuestions.searchTimeoutRef)
        clearTimeout(this.wfQuestions.searchTimeoutRef);
      this.wfQuestions.items = [];

      this.wfQuestions.searchTimeoutRef = setTimeout(async () => {
        this.fetchWorkflowQuestion();
      }, 200);
    },
    filterWfQuestions2() {
      if (this.wfQuestions2.searchTimeoutRef)
        clearTimeout(this.wfQuestions2.searchTimeoutRef);
      this.wfQuestions2.items = [];
      this.wfQuestions2.searchTimeoutRef = setTimeout(async () => {
        this.fetchWorkflowQuestion2();
      }, 200);
    },
    filterWfQuestions3() {
      if (this.wfQuestions3.searchTimeoutRef)
        clearTimeout(this.wfQuestions3.searchTimeoutRef);
      this.wfQuestions3.items = [];
      this.wfQuestions3.searchTimeoutRef = setTimeout(async () => {
        this.fetchWorkflowQuestion3();
      }, 200);
    },
    async loadMoreWorkflowQuestions(_, __, isIntersecting) {
      if (!isIntersecting || !this.wfQuestions.next) return;
      this.wfQuestions.page = this.wfQuestions.next;
      this.wfQuestions.loading = true;
      await this.fetchWorkflowQuestion();
    },
    async loadMoreWorkflowQuestions2(_, __, isIntersecting) {
      if (!isIntersecting || !this.wfQuestions2.next) return;
      this.wfQuestions2.page = this.wfQuestions2.next;
      this.wfQuestions2.loading = true;
      await this.fetchWorkflowQuestion2();
    },
    async loadMoreWorkflowQuestions3(_, __, isIntersecting) {
      if (!isIntersecting || !this.wfQuestions3.next) return;
      this.wfQuestions3.page = this.wfQuestions3.next;
      this.wfQuestions3.loading = true;
      await this.fetchWorkflowQuestion3();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  padding-top: 8px;
  flex-wrap: wrap;
  .modal_title {
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #353542;
  }
  .close_icon {
    margin-left: auto;
  }
}
.modal_content {
  margin-top: 16px;
  position: relative;
  .field_container {
    display: flex;
    align-items: center;
    .label_content {
      margin-right: 14px;
      transform: translateY(-12px);
    }
  }
  .operations_container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
    height: 60px;
    margin-bottom: 24px;
    .operation_item {
      width: 46px;
      height: 46px;
      border: 1px solid #707080;
      border-radius: 6px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 32px;
      font-weight: 400;
      &:hover,
      &.active {
        background: #f5f8ff;
        color: #2536cc;
      }
    }
  }
  .field_title {
    font-size: 22px;
    font-weight: 500;
    margin-bottom: 16px;
    color: #353542;
  }

  .input_group {
    display: flex;
    flex-direction: column;
    gap: 16px;
    .group_label {
      flex: none;
      width: 80px;
      height: 42px;
      display: flex;
      align-items: center;
      font-family: Inter;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      color: #353542;
    }
    .input_section {
      width: 100%;
      flex: none;
      display: flex;
      gap: 16px;
      .action_type {
        display: flex;
        align-items: center;
        gap: 4px;
        border-bottom: 1px solid #353542;
        height: 80px;
        width: 100%;
        .action_label {
          text-decoration: underline;
          font-weight: bold;
          font-size: 16px;
          color: #353542;
        }
      }
      .action_section {
        display: flex;
        flex-direction: column;
      }
      & > * {
        flex: 1;
      }
      .inputs {
        display: flex;
        gap: 16px;
        & > * {
          width: calc(50% - 8px);
          flex: none;
        }
      }
    }
  }
  .advanced_section {
    .advanced_header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 16px;
      cursor: pointer;
      .chevron_btn {
        width: 24px;
        flex: none;
        transition: all 0.3s ease-out;
        &.expanded {
          transform: rotate(90deg);
        }
      }
      .header_label {
        flex: none;
        width: 160px;
        align-items: center;
        font-family: Inter;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
        color: #353542;
      }
    }
    .advanced_content {
      .advanced_input {
        display: flex;
        .input_label {
          width: 176px;
          height: 42px;
          display: flex;
          align-items: center;
          color: #353542;
          font-family: Inter;
          font-size: 14px;
          line-height: 18px;
          font-style: normal;
          font-weight: 400;
        }
        .input_section {
          width: calc(100% - 176px);
          flex: none;
        }
      }
      .checkbox_item {
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        label {
          width: 176px;
          color: #353542;
          font-family: Inter;
          font-size: 14px;
          line-height: 18px;
          font-style: normal;
          font-weight: 400;
        }
        input {
          width: 18px;
          height: 18px;
          cursor: pointer;
        }
      }
    }
  }
  .progression {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 10;
  }
}
.modal_footer {
  display: flex;
  justify-content: flex-end;
  align-content: center;
  padding: 8px 0;
  gap: 16px;
}

.tooltip_container {
  position: relative;
  display: flex;
  align-items: center;
  transform: translateY(-1px);
  .tooltip_item {
    position: absolute;
    top: 0;
    transform: translate(102%, -10px);
    right: 0;
  }
  .msg_contain {
    position: relative;
    display: none;
    width: 110px;
    color: #353542;
    font-size: 12px;
    padding: 6px;
    background: #d9d9da;
    border-radius: 4px;
    z-index: 100;
    &::before {
      content: "";
      border-width: 12px;
      border-style: solid;
      border-color: transparent;
      border-top: 15px solid #d9d9da;
      position: absolute;
      top: 10px;
      left: -20px;
      transform: rotate(90deg);
    }
  }
  &:hover {
    .msg_contain {
      display: block;
      text-align: center;
      transition: 125ms;
    }
  }
}
</style>
